import Button from "@app/components/button";
import ConfirmModal from "@app/components/confirm-modal";
import CreateLinkModal from "@app/components/link-modal/link-modal.component";
import { addToast } from "@app/components/toast/toast.service";
import {
  PathnameUrl,
  Role,
  SystemMessage,
  USER_INFO_KEY,
} from "@app/constants";
import LinkService from "@app/services/http/link.service";
import { openPortalDialog } from "@app/services/modal.service";
import { Link } from "@app/types";
import { formatDate } from "@app/utils/util";
import useForceUpdate from "@core/hooks/use-force-update.hook";
import useObservable from "@core/hooks/use-observable.hook";
import StorageService from "@core/services/storage";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function LinkManagement() {
  const [link, setLinks] = useState<Link[]>([]);

  const [update, forceUpdate] = useForceUpdate();

  const { subscribeOnce, subscribeUntilDestroy } = useObservable();

  const navigate = useNavigate();

  const acc = StorageService.getObject(USER_INFO_KEY) as any;

  if (!acc) {
    navigate(PathnameUrl.LOGIN);
  }

  useEffect(() => {
    subscribeUntilDestroy(LinkService.getLinks(), (res) => {
      if (res.length) {
        setLinks(res);
      } else {
        setLinks([]);
      }
    });
  }, [update]);

  const handleCreateLink = () => {
    const createLinkModalObs = openPortalDialog(CreateLinkModal);

    createLinkModalObs.afterClosed().subscribe((data) => {
      if (data?.link) {
        addToast({ text: SystemMessage.SUCCESS });
        forceUpdate();
      }
    });
  };

  const handleDeleteLink = (linkId: string) => {
    const deleteLinkObs = openPortalDialog(ConfirmModal, {
      message: "Bạn có chắc chắn xóa Link này không?",
    });

    deleteLinkObs.afterClosed().subscribe((data) => {
      if (data?.isAccept) {
        subscribeOnce(LinkService.deleteLink(linkId), () => {
          addToast({ text: SystemMessage.DELETE_SUCCESS });
          forceUpdate();
        });
      }
    });
  };

  return (
    <div className="w-full mx-auto mt-4 pb-4">
      <div className="flex items-center justify-end pb-2 px-2 border-b border-[#409EFF]">
        {acc?.role === Role.ADMIN && (
          <Button
            label="Thêm Link"
            width="fit-content"
            className="px-2 text-sm"
            onClick={handleCreateLink}
          />
        )}
      </div>
      <div className="px-2 overflow-x-auto mt-2">
        <div className="inline-block min-w-full shadow-md rounded-lg overflow-hidden">
          <table className="min-w-full leading-normal">
            <thead className="text-white">
              <tr className="border-b-2 border-gray-200 bg-[#409EFF] text-sm">
                <th className="p-3 text-left w-52">ID</th>
                <th className="p-3 text-left w-72">Link</th>
                <th className="p-3 text-left w-32">Level</th>
                <th className="p-3 text-left w-72">Thời gian tạo</th>
                {acc?.role === Role.ADMIN && (
                  <th className="p-3 text-left w-52">Hành động</th>
                )}
              </tr>
            </thead>
            <tbody>
              {!!link.length &&
                link.map((item) => (
                  <tr
                    key={item._id}
                    className="border-b border-gray-200 text-sm hover:bg-[#51b83c2c]"
                  >
                    <td className="p-3">{item._id}</td>
                    <td className="p-3">{item.link}</td>
                    <td className="p-3">{item.level}</td>
                    <td className="p-3">{formatDate(item.createdAt)}</td>

                    {acc?.role === Role.ADMIN && (
                      <td className="p-3">
                        <Button
                          label="Xóa"
                          width="fit-content"
                          className="px-2 text-sm"
                          onClick={() => handleDeleteLink(item._id)}
                        />
                      </td>
                    )}
                  </tr>
                ))}
            </tbody>
          </table>
          {!link.length && (
            <div className="flex justify-center">Không có dữ liệu</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default LinkManagement;
